<template>
  <transition name="modal">
    <div class="modal-mask" :class="classes">
      <div class="modal-wrapper" @click.self="close">
        <div class="modal-container">
          <div class="modal-header">
            <slot name="modal-header" :close="close"></slot>
          </div>
          <div class="modal-body">
            <slot name="modal-body"></slot>
          </div>
          <div class="modal-footer" v-if='this.$slots["modal-footer"]'>
            <slot name="modal-footer"></slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: ['classes'],
  methods: {
    close() {
      this.$emit('close');
    },
  },
};
</script>
